import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import { immerable, produce } from 'immer';
import { Map } from 'immutable';

import { SwitchableVersionProjectItemEntity } from './switchable-version-project-item.entity';

export interface ISwitchableVersionProjectListExtra
	extends IListColumnConfig<SwitchableVersionProjectItemEntity> {
	isFixed?: boolean;
	isSelectable?: boolean;
	isSearchable?: boolean;
	isInGroup?: boolean;
	isVisible?: boolean;
	canBeHidden?: boolean;
	canBeReordered?: boolean;
	canBeChosen?: boolean;
	format?: string;
}

interface IConsumedProjectListEntity
	extends IListAttrs<SwitchableVersionProjectItemEntity> {
	availableColumns: Map<string, ISwitchableVersionProjectListExtra>;
}

const entityDefaults: IConsumedProjectListEntity = {
	elements: Map(),
	availableColumns: Map(),
};

export class SwitchableVersionProjectListEntity
	implements
		IConsumedProjectListEntity,
		IListOperations<
			SwitchableVersionProjectListEntity,
			SwitchableVersionProjectItemEntity
		>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;

	public static build(
		availableCols: Array<ISwitchableVersionProjectListExtra>
	): SwitchableVersionProjectListEntity {
		const inst = new SwitchableVersionProjectListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, ISwitchableVersionProjectListExtra]>());
		inst.availableColumns = Map(cols);
		return inst;
	}

	private constructor() {}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<SwitchableVersionProjectItemEntity>
	> {
		return this.availableColumns;
	}
	public setElements(
		elems: Map<string, SwitchableVersionProjectItemEntity>
	): SwitchableVersionProjectListEntity {
		return produce(this, (draft: SwitchableVersionProjectListEntity) => {
			draft.elements = elems;
		});
	}
}
